import styled from 'styled-components';
import { Radio } from 'antd';

export const StyledRadio = styled(Radio)`
  color: #fff;
  margin-right: 10px;
  margin-bottom: 16px;

  .setur-radio-checked .setur-radio-inner {
    border-color: ${({ theme }) => theme.palette.primaryBrand};
    background-color: ${({ theme }) => theme.palette.white};

    &:after {
      transform: scale(0.5);
      background-color: ${({ theme }) => theme.palette.primaryBrand};
    }
  }
`;
